import React from 'react';
import { observer } from 'mobx-react-lite';
import { useSearchStore } from '../../../../providers/SearchStoreProvider';
import { Button } from '../../../Button';

export const ShowMore = observer(({ length, url, amount, setPage, main }) => {
  const { mainResult } = useSearchStore();

  const isShowButton = (lengthCard, amountCard) =>
    lengthCard >= 10 && lengthCard < amountCard;

  return (
    isShowButton(length, amount) && (
      <Button
        view={url === 'black_friday' ? 'textcResultBf' : 'textResult'}
        onClick={() => {
          if (main) {
            mainResult.onMore();
          } else {
            // eslint-disable-next-line no-unused-expressions
            setPage && setPage();
          }
        }}
        fullWidth
        topGap
      >
        ПОКАЗАТЬ БОЛЬШЕ КРУИЗОВ
      </Button>
    )
  );
});
